__turbopack_context__.v({
  "videoModal": "VideoModal-module-scss-module__P2hSCa__videoModal",
});
